import { PopoverInstance, PopoverWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { Cluster } from '../types/Cluster';

export type ClusterNamePopoverProps = Readonly<{
  cluster: Cluster;
}>;

export function ClusterNamePopover(props: ClusterNamePopoverProps) {
  const popoverInstance = React.useRef<PopoverInstance>(null);

  return (
    <PopoverWidget
      testId='cluster-name-popover'
      aria-describedby='popoverDescription'
      placement='right'
      popoverContent={<form>
        <p id='popoverDescription'>{Messages.dataConnectSiteSettingsClusterId()} {props.cluster.clusterId}</p>
      </form>}
      ref={popoverInstance}
      title={Messages.dataConnectSiteSettingsClusterId()}
      showTitleBar={false}
      triggerElement={
        <span className={'tb-data-grid-cell-text-data-connect'} data-tb-test-id={'cluster-name-cell'} style={{paddingLeft: 0}}>
          {props.cluster.displayName}
        </span>
      }
    />
  );
}
